module.exports = __webpack_public_path__ + "img/shoot_00015.aa92e039.png";